<template>
  <div class="auth-form">
    <Login @close="close" />
  </div>
</template>

<script>
import Login from "./AuthForm/Login";

export default {
  name: "AuthForm",
  components: { Login },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
